import {
  SET_TOKEN,
  SET_LANG_STATE,
  SET_MASK_STATUS
} from './mutation-types.js'

export default {
  // 设置TOKEN
  [SET_TOKEN] (state, token) {
    state.token = token
  },
  [SET_LANG_STATE] (state, lang = 'en') {
    state.lang = lang
  },
  // 设置是否显示订阅遮罩层 左侧菜单与顶部导航，应用在IFRAME
  [SET_MASK_STATUS] (state, status = false) {
    state.showSubscribeMask = status
  }
}

